import { render } from "./CbimSteps.vue?vue&type=template&id=00a94774&scoped=true&ts=true"
import script from "./CbimSteps.vue?vue&type=script&lang=ts"
export * from "./CbimSteps.vue?vue&type=script&lang=ts"

import "./CbimSteps.vue?vue&type=style&index=0&id=00a94774&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a94774"]])

export default __exports__